import { IUsPsAddressResponse } from '@nkr/models/usps-address-response';

export interface IAddressValidationResponse {
    data: {
        success: boolean,
        results: IUsPsAddressResponse
    }
}